import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export const FAQS = [
  {
    q: 'What is Northwest Title Alliance?',
    a: 'Northwest Title Alliance is a Washington-based company that builds AI-powered software for title professionals. Its products include the AXIOM virtual underwriter family, ART, an AI-rendered title plant, and TrueNorth, ALTA/NSPS survey intelligence. It serves national customers under the DBA Northwest Tech Alliance.',
  },
  {
    q: 'What is AXIOM?',
    a: 'AXIOM is an AI virtual underwriter that answers complex title underwriting questions instantly, in any state. It ships in purpose-built editions: AXIOM for Underwriters, AXIOM for Lenders, AXIOM for Agents, and AXIOM for Attorneys are live today, with editions for National Agents and Commercial coming soon.',
  },
  {
    q: 'What is ART (AI Rendered Title)?',
    a: 'ART is an OIC-compliant, AI-powered title plant with records back to State Patent — fundamentally changing how title searches are performed in Washington State.',
  },
  {
    q: 'Which states does AXIOM cover?',
    a: 'AXIOM provides state-specific underwriting guidance in any U.S. state — and every state is built to the same highest level of underwriting expertise.',
  },
  {
    q: 'How do I get access or pricing?',
    a: 'Email sales@northwesttitlealliance.com or call the sales line at (253) 453-1754. The team will walk you through a demo tailored to your operation.',
  },
  {
    q: 'What is the difference between Northwest Title Alliance and Northwest Tech Alliance?',
    a: 'They are the same company. Northwest Title Alliance is the legal name; Northwest Tech Alliance is the DBA used for tech products offered to customers outside the Pacific Northwest.',
  },
];

const FAQ = () => (
  <section id="faq" className="relative py-24 bg-white" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-[#3E5C76]">FAQ</div>
      <h2 className="mt-3 font-serif text-3xl md:text-4xl font-medium tracking-[-0.02em] text-[#0B2545]">
        Frequently asked questions
      </h2>
      <Accordion type="single" collapsible className="mt-10">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-slate-200">
            <AccordionTrigger
              className="text-left text-[15.5px] font-semibold text-[#0B2545] hover:text-[#3E5C76] hover:no-underline py-5"
              data-testid={`faq-question-${i}`}
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[14.5px] leading-relaxed text-slate-600 pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
